import router from '@/router'

export default {
  state: {
    page: [],
    detailedPage: []
  },
  mutations: {
    setPage (state, payload) {
      state.page = payload
    },
    setDetailedPage (state, payload) {
      state.detailedPage = payload
    }
  },
  actions: {
    async setPage (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/admin/page`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      res = await res.json()
      this.commit('setPage', await res)
    },

    async setDetailedPage (ctx, payload) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/admin/page/${payload}`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      res = await res.json()
      this.commit('setDetailedPage', await res)
    },

    async deletePage (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/page/${payload}`, {
        method: 'DELETE',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      }).then(res => {
        if (res.status === 200) {
          ctx.commit('setMessage', {
            type: 'success',
            text: 'Страница успешно удалена'
          })
        } else {
          ctx.commit('setMessage', { type: 'error', text: 'Ошибка удаления' })
        }
        ctx.dispatch('setPage')
      })
        .catch(error => console.log('error', error))
    },

    async createPage (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/page`, {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token')
        },
        body: payload
      })
        .then(res => {
          if (res.status === 201) {
            router.push('/admin/page')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Создание страницы прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка создания'
            })
          }
        })
        .catch(error => console.log('error', error))
    },

    async editPage (ctx, payload) {
      await fetch(`${ctx.getters.getUrlApi}api/admin/page/${payload.id}`, {
        method: 'POST',
        body: payload.data
      })
        .then(res => {
          if (res.status === 200) {
            router.push('/admin/page')
            ctx.commit('setMessage', {
              type: 'success',
              text: 'Изменение страницы прошло успешно'
            })
          } else {
            ctx.commit('setMessage', {
              type: 'error',
              text: 'Ошибка изменения'
            })
          }
        })
        .catch(error => console.log('error', error))
    }
  },
  getters: {
    getAdminPage: (s) => s.page,
    getDetailedPage: (s) => s.detailedPage
  }
}
